import React from "react";
import { commentStatusEnum } from "constants/globalEnum";
import SmsIcon from '@material-ui/icons/Sms';
import MessageIcon from '@material-ui/icons/Message';

const CommentIcon = ({
    commentStatus,
    ...rest
}) => {

    if(commentStatus && commentStatus !== commentStatusEnum.RESOLVED) {
        return (
            <SmsIcon style={{cursor:'pointer'}} color="primary" {...rest} />
        )
    }
    if(commentStatus === commentStatusEnum.RESOLVED) {
        return <MessageIcon style={{cursor: 'pointer'}} {...rest} />;
    }
    return null;
};

export default CommentIcon;